<div class="donationdrive-modal-parent" style="top: 25px;">
  <div class="ui_modal donationdrive-modal" style="border-radius: 10px;">
    <a href="javascript:void(0)" class="ui_close" (click)="closeIcon()"></a>
    <div class="ui_modal_text" style="font-size: 16px;line-height: 1.5;margin-bottom: 5px !important;flex-direction: column;">
      <p style="font-family: 'montserratlight';align-self: center;color: #FE5200;font-size: 2em;font-weight: bolder;"><strong>Special Ramadan Promotion</strong></p>
      <p style="font-family: 'montserratlight';align-self: start;font-size: 1.17em;color: teal;"> Tanzeel has a group of new teachers ready to teach! Nominate / invite up to 3 friends/family for a FREE month of Qur’an classes during Ramadan! (one 30 mins session/week: Apr 2-30)</p>
      
    </div>
    <div class="ui_modal_content" style="overflow: auto;">
      <div class="sh-grid-1"  >
        <div class="formbox" style="padding-top: 5px;padding-left: 10px;">
          <!--h3>More information</h3-->
          <form [formGroup]="studentinfoForm">
            <div class="form-style-outer">
              <div class="sh-grid-1" style="padding: 0px 5px;">
                <div class="mat-div" [class.is-active]="emailsFldInFocus==true" [class.is-completed]="emailsFldInFocussed()==true || emailsFldInFocus==true">
                  <label class="mat-label">Emails (comma seperated)</label>
                  <textarea class="mat-input" style="max-height: 100px;line-height: 135%;overflow: hidden;" (keyup)="auto_grow($event)" formControlName="emails" (focus)="emailsFldInFocus=true" (blur)="emailsFldInFocus=false"></textarea>

                </div>
              </div>
              
              
            </div>
          </form>
        </div>
      </div>
      

    </div>
    <div class="ui_modal_text" style="font-size: 16px;line-height: 1.5;margin-bottom: 5px !important;flex-direction: column;">
      <p style="font-family: 'montserratlight';align-self: start;color: teal;"><strong>Note:</strong> The invitees should make a new account on the system using the emails provided above for the promotion to work. You may use it for your own family.</p>
      
    </div>
    <div class="ui_modal_btns">
      <a class="ui_btn ui_btn_primary" href="javascript:void(0)" (click)="submit()" >Submit</a>
      <a class="ui_btn ui_btn_basic" href="javascript:void(0)" (click)="closeIcon()">Do it later</a>

    </div>
  </div>
</div>
